import { supabase } from './supabaseClient';

// --- SURVEYS ---

/**
 * Fetch all surveys, ordered by newest first
 */
export const fetchSurveys = async () => {
  const { data, error } = await supabase
    .from('surveys')
    .select('*')
    .order('created_at', { ascending: false });

  if (error) throw error;
  return data || [];
};

/**
 * Fetch a single survey by ID
 */
export const fetchSurveyById = async (id) => {
  const { data, error } = await supabase
    .from('surveys')
    .select('*')
    .eq('id', id)
    .single();

  if (error) throw error;
  return data;
};

/**
 * Create a new survey
 */
export const createSurvey = async (surveyData) => {
  const { data, error } = await supabase
    .from('surveys')
    .insert([surveyData])
    .select();

  if (error) throw error;
  return data;
};

/**
 * Update an existing survey (title, questions, etc)
 */
export const updateSurvey = async (id, updates) => {
  const { data, error } = await supabase
    .from('surveys')
    .update(updates)
    .eq('id', id);

  if (error) throw error;
  return data;
};

/**
 * Delete a survey by ID
 */
export const deleteSurvey = async (id) => {
  const { error } = await supabase
    .from('surveys')
    .delete()
    .eq('id', id);

  if (error) throw error;
  return true;
};

// --- RESPONSES ---

/**
 * Submit a user's answers to a survey
 */
export const submitResponse = async (surveyId, answers) => {
  const { error } = await supabase
    .from('responses')
    .insert([{ 
      survey_id: surveyId, 
      answers: answers,
    }]);

  if (error) throw error;
  return true;
};

/**
 * Get the total count of responses for a specific survey
 */
export const fetchResponseCount = async (surveyId) => {
  const { count, error } = await supabase
    .from('responses')
    .select('*', { count: 'exact', head: true })
    .eq('survey_id', surveyId);

  if (error) throw error;
  return count || 0;
};

/**
 * Get all actual response data (for Excel export)
 */
export const fetchSurveyResponses = async (surveyId) => {
  const { data, error } = await supabase
    .from('responses')
    .select('*')
    .eq('survey_id', surveyId);

  if (error) throw error;
  return data || [];
};